import React, { useRef } from 'react'
import "./Mission_Vission.css"

function Mission_Vission() {

    return (
        <section className='Mission_Vission margin_section'>
            <div className="container">
                <div className="row ">


                    <div className="col-md-6">
                        <div className='row'>

                            <div className="col-md-8 col-8">
                                <div className="img_corder_holder">
                                    <div className='img_holder'>
                                        <img className="about_us_img"
                                            src={process.env.PUBLIC_URL + "/assets/images/about/mission-vission/mission_1.png"}
                                            alt="about us img" />
                                    </div>

                                    <div className="img_badge_holder">
                                        00 Years
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4 col-4 d-flex justify-content-center align-items-center">
                                <div className='vdo_holder vdo_holder_1'>
                                    <img
                                        className="about_us_vdo"
                                        src={process.env.PUBLIC_URL + "/assets/images/about/mission-vission/mission_2.png"}
                                        alt="about us vdo"
                                    />

                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6">
                        <div className="text_holder">
                            <div>

                                <h3>Our Mission</h3>
                                <p>
                                    At CAMPUS DEAL , our mission is to bridge the gap between customers, service vendors, and industry experts by providing a seamless, reliable, and technology-driven platform for discovering and managing construction and maintenance services. We aim to empower individuals and businesses by making trusted services accessible — anytime, anywhere — with just a few taps.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row mt-5">
                    <div className="col-md-6 order-md-1 order-2 ">
                        <div className="text_holder">
                            <div>
                                <h3>Built for Everyone</h3>
                                <p>
                                    CAMPUS DEAL is designed to serve a wide range of users — from individuals managing home repairs to professionals running large construction projects. Whether you're a customer, a vendor, or an industry expert, CAMPUS DEAL brings all your service needs under one roof.
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-md-6 order-md-2 order-1">
                        <div className='row'>
                            <div className="col-md-4 col-4 d-flex justify-content-center align-items-center">
                                <div className='vdo_holder vdo_holder_2'>
                                    <img
                                        className="about_us_vdo"
                                        src={process.env.PUBLIC_URL + "/assets/images/about/mission-vission/vission_2.png"}
                                        alt="about us vdo"
                                    />

                                </div>
                            </div>
                            <div className="col-md-8 col-8">
                                <div className="img_corder_holder">
                                    <div className='img_holder'>
                                        <img className="about_us_img"
                                            src={process.env.PUBLIC_URL + "/assets/images/about/mission-vission/vission_1.png"}
                                            alt="about us img" />
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Mission_Vission;
